<template>
  <div class="modal fade" :class="{'is-open': open}">
    <div class="modal-dialog" style="width: 900px;">
      <div class="modal-content">
        <div class="modal-header">
          <a @click="$emit('close')" class="close">
            <i class="icon-close"></i>
          </a>
          <div class="col-9 pl-0">
            <h3 class="modal-title">
              差額升等VIP
            </h3>
          </div>
        </div>
        <div class="modal-body">
          <table id="vip-table" class="datatable table insurance-green">
            <thead>
              <tr>
                <th>目標名單類型</th>
                <th>保戶姓名</th>
                <th>保戶ID</th>
                <th>現行等級</th>
                <th>目標等級</th>
                <th>保費差額</th>
                <th>手機號碼</th>
              </tr>
            </thead>
            <tbody>
              <tr class="table-warning">
                <td>明年度降等保戶目標名單</td>
                <td>陳君君</td>
                <td>A223XXX789</td>
                <td>白金VIP</td>
                <td>維持<br/>白金VIP</td>
                <td>34萬</td>
                <td>0922133647</td>
              </tr>
              <tr>
                <td>明年度降等保戶目標名單</td>
                <td>陳君君</td>
                <td></td>
                <td>白金VIP</td>
                <td>維持<br/>白金VIP</td>
                <td>34萬</td>
                <td>0922133647</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'VipModal',
  props: {
    open: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    open: 'renderTable'
  },
  data () {
    return {
      vipTable: null
    }
  },
  methods: {
    renderTable (value) {
      if(value && !this.vipTable) {
        setTimeout(() => {
          this.vipTable = window.$('#vip-table').DataTable({
            ordering: true,
            paging: false,
            searching: false
          })
        }, 500)
      }
    }
  }
}
</script>
